export const stats = [
  { value: '+60', label: 'Lessons Ready' },
  { value: '+1,500', label: 'Teachers & Trainers' },
  { value: '3,000+', label: 'Hours Saved' },
  { value: '99%', label: 'Would Recommend It' },
]

export const differenceStats = [
  { value: '+60', label: 'Ready-to-Teach Hospitality Lessons' },
  { value: '6', label: 'Complete Digital Volumes' },
  { value: '100%', label: 'Instantly Downloadable' },
]

export const beforeItems = [
  'Hours building hotel lessons from scratch',
  'Generic textbooks with no real guest situations',
  'Students who freeze in front of real guests',
  'No clear way to assess service English',
  'Role-plays that feel forced and unrealistic',
]

export const afterItems = [
  "5-minute review and you're set",
  'Realistic front-desk and guest-service scenarios',
  'Phrases staff can use on day one at work',
  'Rubrics, checklists, and assessments ready',
  'Students handling guests with total confidence',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Teaching hotel English without real front-desk scenarios to practice',
  },
  {
    emoji: '⏱️',
    text: 'Spending your entire Sunday adapting general English to hospitality',
  },
  {
    emoji: '🤷',
    text: 'Struggling to find role-plays that actually sound like real guests',
  },
  {
    emoji: '📋',
    text: 'No clear rubrics to assess how students handle a check-in or complaint',
  },
  {
    emoji: '😴',
    text: "Students losing interest because the material isn't connected to their job",
  },
  { emoji: '🌙', text: 'Still not ready for Monday by Sunday night' },
]

export const packItems = [
  {
    emoji: '📚',
    title: '6 Guest-Journey Volumes',
    text: 'From the first reservation call to the final farewell — the full hotel guest cycle',
  },
  {
    emoji: '🎭',
    title: 'Ready-to-Run Role-Plays',
    text: 'Front desk, concierge, and phone scenarios with guest and staff cards',
  },
  {
    emoji: '✏️',
    title: 'Step-by-Step Lesson Scripts',
    text: 'Teacher prompts that tell you exactly how to lead the class in seconds',
  },
  {
    emoji: '🛎️',
    title: 'Key Phrase Banks',
    text: 'Polite, professional language staff can use with guests from day one',
  },
  {
    emoji: '📊',
    title: 'Assessments & Rubrics',
    text: 'Speaking checklists and service-standard rubrics for every volume',
  },
  {
    emoji: '🔑',
    title: 'Full Answer Keys',
    text: 'Grading is finally instant, accurate, and stress-free',
  },
]

export const samplePages = [
  {
    level: 'Worksheet',
    caption: 'Lesson 01 · Worksheet',
    title: 'Greeting & Opening Exchange',
    text: 'Match phrases to their purpose, order a check-in dialogue, and write your own opening.',
    image:
      'https://cdn.magicpatterns.com/uploads/sh6LKM2Rw8MncQVC4WNCP5/02-worksheet.webp',
  },
  {
    level: 'Sequence',
    caption: 'Lesson 03 · Visual Sequence',
    title: 'Arrange the Arrival Sequence',
    text: 'Six photo panels to put in order with First, Next, Then, Finally.',
    image:
      'https://cdn.magicpatterns.com/uploads/6dsp4TVU6nGFCHwL5TATav/03-visual-sequence.webp',
  },
  {
    level: 'Map',
    caption: 'Lesson 04 · Model & Teaching Route',
    title: 'Introduce Hotel Facilities',
    text: 'An illustrated lobby map, a six-step teaching route, and a model dialogue.',
    image:
      'https://cdn.magicpatterns.com/uploads/hE7XrLJ337vZ5buZzVbCvu/01-hotel-facilities.webp',
  },
  {
    level: 'Roles',
    caption: 'Lesson 05 · Role-Play Cards',
    title: 'Early Arrival Role Cards',
    text: 'Cut-out staff and guest cards for two rounds, plus an observer checklist.',
    image:
      'https://cdn.magicpatterns.com/uploads/cEGD1EM4RUu8nQWrzdogkc/04-role-play-cards.webp',
  },
  {
    level: 'Key',
    caption: 'Lesson 06 · Teacher Key',
    title: 'Answers, Support & Stretch',
    text: 'Full answers for every task, a feedback checklist, and ideas to support or stretch.',
    image:
      'https://cdn.magicpatterns.com/uploads/uJhUduiz4q1DPw1Ehn8AGw/05-teacher-answer-key.webp',
  },
]

export const instantItems = [
  'The 6 complete digital volumes (Reservations to Training Plans)',
  'Role-plays, games, and simulations for every guest situation',
  'Visual lessons with key hospitality vocabulary',
  'Teacher scripts that tell you exactly what to say',
  'Answer keys for every worksheet and assessment in the toolkit',
]

export const bonuses = [
  {
    title: 'Classroom Role-Play Prompt Set',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/67783a58-00bb-41c9-9a05-8093c8d31e6d.jpg',
  },
  {
    title: 'Hospitality Dialogue Building Blocks',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/61d6b1ce-4d7d-4672-9793-79ed28c4be98.jpg',
  },
  {
    title: 'Editable Lesson Adaptation Templates',
    was: '$17',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/90fdba9f-02a8-4a1b-813a-6c20f920c12f.jpg',
  },
  {
    title: '5-Minute Hospitality Warm-Up Bank',
    was: '$15',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/241419b6-933c-4dfd-9c70-614b34547eb9.jpg',
  },
  {
    title: 'Hospitality Pronunciation Clarity Cards',
    was: '$17',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/77e10f7d-2f3d-48d4-a7a6-2c60cf224217.jpg',
  },
]

export const offerRows = [
  { label: 'Hospitality English Ready™ (6 Digital Volumes)', value: '$77' },
  { label: '5 Exclusive Strategic Bonuses', value: '$87' },
]

export const testimonials = [
  {
    quote:
      'I have my Sundays back. My hotel students finally practice situations they actually face at the front desk.',
    name: 'Sarah M.',
    location: 'USA 🇺🇸',
  },
  {
    quote:
      'The complaint-handling volume made a huge difference. My trainees stopped freezing with difficult guests.',
    name: 'Ella B.',
    location: 'UK 🇬🇧',
  },
  {
    quote:
      'The role-play cards alone transformed my tourism classes this year. Worth every penny.',
    name: 'Maya K.',
    location: 'Canada 🇨🇦',
  },
  {
    quote:
      'Finally, a professional hospitality English resource that is organized and ready to print.',
    name: 'Sophie L.',
    location: 'Australia 🇦🇺',
  },
]

export const faqs = [
  {
    q: 'How do I receive the material?',
    a: "Instantly. After payment, you'll get a download link in your email to access all PDF and digital files.",
  },
  {
    q: "Does this work if I've never worked in a hotel?",
    a: "Yes. The scripts and role-plays tell you exactly what to do and say, so you teach hospitality English like an industry pro from day one.",
  },
  {
    q: 'Who is this toolkit for?',
    a: 'English teachers, hotel trainers, and hospitality or tourism schools. It follows the full guest journey and works for teens and adults preparing for, or already working in, hospitality.',
  },
  {
    q: 'Are the bonuses included in the price?',
    a: 'Yes, if you purchase during the launch offer, all 5 bonuses are included for life.',
  },
  {
    q: 'Do I have to pay monthly?',
    a: 'No. This is a one-time payment for lifetime access. No hidden fees or subscriptions.',
  },
]
